import intersection from 'lodash/intersection';

const ADDRESS_REQUIRED_FIELDS = [
  // for business
  'businessAddressLine1',
  'businessAddressCity',
  'businessAddressState',
  'businessAddressCountry',
  'businessAddressZip',

  // for account member
  'country'
];

const FULL_NAME_REQUIRED_FIELDS = ['firstName', 'lastName'];

export const validateRequiredField = (invalidFields = [], key = '') => {
  if (key === 'address') {
    // for businessAddress
    return intersection(ADDRESS_REQUIRED_FIELDS, invalidFields).length > 0;
  }

  if (key === 'fullName') {
    return intersection(FULL_NAME_REQUIRED_FIELDS, invalidFields).length > 0;
  }

  return invalidFields.includes(key);
};

export const getInvalidFieldsByType = (fields = [], fieldType = '') =>
  fields.filter(({ type }) => type === fieldType).map(({ field }) => field);
